
import Vue from "vue";
import { SearchAPIModels } from 'search-api-client';

export default Vue.extend({
  name: "ChosenDateTags",
  props: {
    tags: {
      type: Array as () => SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => []
    }
  },
  methods: {
    clearTag: function (tag: SearchAPIModels.GenericSearchResponseFacetsCreatedItem) {
      this.$emit("clearTag", tag);
    }
  }
});
